export enum VerificationStatus {
  UNCONFIRMED = 'unconfirmed',
  VERIFIED = 'verified',
}
